import WalletActionTypes from "./wallet.types";

// Fetch supported countries
export const fetchCountriesStart = () => ({
  type: WalletActionTypes.FETCH_COUNTRIES_START,
});

export const fetchCountriesSuccess = (countries) => ({
  type: WalletActionTypes.FETCH_COUNTRIES_SUCCESS,
  payload: countries,
});

export const fetchCountriesFailure = (error) => ({
  type: WalletActionTypes.FETCH_COUNTRIES_FAILURE,
  payload: error,
});

// Update user location
export const updateLocationStart = (token, country, location) => ({
  type: WalletActionTypes.UPDATE_LOCATION_START,
  payload: { token, country, location },
});

export const updateLocationSuccess = (data) => ({
  type: WalletActionTypes.UPDATE_LOCATION_SUCCESS,
  payload: data,
});

export const updateLocationFailure = (error) => ({
  type: WalletActionTypes.UPDATE_LOCATION_FAILURE,
  payload: error,
});

// Fetch exchange rates
export const fetchRatesStart = () => ({
  type: WalletActionTypes.FETCH_RATES_START,
});

export const fetchRatesSuccess = (rates) => ({
  type: WalletActionTypes.FETCH_RATES_SUCCESS,
  payload: rates,
});

export const fetchRatesFailure = (error) => ({
  type: WalletActionTypes.FETCH_RATES_FAILURE,
  payload: error,
});

// Initialize deposit
export const initDepositStart = (token, amount, currency, cardId = null) => ({
  type: WalletActionTypes.INIT_DEPOSIT_START,
  payload: { token, amount, currency, cardId },
});

export const initDepositSuccess = (data) => ({
  type: WalletActionTypes.INIT_DEPOSIT_SUCCESS,
  payload: data,
});

export const initDepositFailure = (error) => ({
  type: WalletActionTypes.INIT_DEPOSIT_FAILURE,
  payload: error,
});

// Verify Paystack payment
export const verifyPaystackPaymentStart = (token, reference, depositId) => ({
  type: WalletActionTypes.VERIFY_PAYSTACK_PAYMENT_START,
  payload: { token, reference, depositId },
});

export const verifyPaystackPaymentSuccess = (data) => ({
  type: WalletActionTypes.VERIFY_PAYSTACK_PAYMENT_SUCCESS,
  payload: data,
});

export const verifyPaystackPaymentFailure = (error) => ({
  type: WalletActionTypes.VERIFY_PAYSTACK_PAYMENT_FAILURE,
  payload: error,
});

// Fetch deposit history
export const fetchDepositsStart = (token) => ({
  type: WalletActionTypes.FETCH_DEPOSITS_START,
  payload: { token },
});

export const fetchDepositsSuccess = (deposits) => ({
  type: WalletActionTypes.FETCH_DEPOSITS_SUCCESS,
  payload: deposits,
});

export const fetchDepositsFailure = (error) => ({
  type: WalletActionTypes.FETCH_DEPOSITS_FAILURE,
  payload: error,
});

// Request withdrawal
export const requestWithdrawalStart = (token, data) => ({
  type: WalletActionTypes.REQUEST_WITHDRAWAL_START,
  payload: { token, ...data },
});

export const requestWithdrawalSuccess = (data) => ({
  type: WalletActionTypes.REQUEST_WITHDRAWAL_SUCCESS,
  payload: data,
});

export const requestWithdrawalFailure = (error) => ({
  type: WalletActionTypes.REQUEST_WITHDRAWAL_FAILURE,
  payload: error,
});

// Fetch saved cards
export const fetchCardsStart = (token) => ({
  type: WalletActionTypes.FETCH_CARDS_START,
  payload: { token },
});

export const fetchCardsSuccess = (cards) => ({
  type: WalletActionTypes.FETCH_CARDS_SUCCESS,
  payload: cards,
});

export const fetchCardsFailure = (error) => ({
  type: WalletActionTypes.FETCH_CARDS_FAILURE,
  payload: error,
});

// Fetch balance
export const fetchBalanceStart = (token) => ({
  type: WalletActionTypes.FETCH_BALANCE_START,
  payload: { token },
});

export const fetchBalanceSuccess = (balance) => ({
  type: WalletActionTypes.FETCH_BALANCE_SUCCESS,
  payload: balance,
});

export const fetchBalanceFailure = (error) => ({
  type: WalletActionTypes.FETCH_BALANCE_FAILURE,
  payload: error,
});

// Clear messages
export const clearWalletMessages = () => ({
  type: WalletActionTypes.CLEAR_WALLET_MESSAGES,
});

// Fetch wallet history (merged deposits & withdrawals)
export const fetchWalletHistoryStart = (token) => ({
  type: WalletActionTypes.FETCH_WALLET_HISTORY_START,
  payload: { token },
});

export const fetchWalletHistorySuccess = (history) => ({
  type: WalletActionTypes.FETCH_WALLET_HISTORY_SUCCESS,
  payload: history,
});

export const fetchWalletHistoryFailure = (error) => ({
  type: WalletActionTypes.FETCH_WALLET_HISTORY_FAILURE,
  payload: error,
});

// Stripe Connect - Create account
export const createStripeConnectStart = (token) => ({
  type: WalletActionTypes.CREATE_STRIPE_CONNECT_START,
  payload: { token },
});

export const createStripeConnectSuccess = (data) => ({
  type: WalletActionTypes.CREATE_STRIPE_CONNECT_SUCCESS,
  payload: data,
});

export const createStripeConnectFailure = (error) => ({
  type: WalletActionTypes.CREATE_STRIPE_CONNECT_FAILURE,
  payload: error,
});

// Stripe Connect - Fetch status
export const fetchStripeConnectStatusStart = (token) => ({
  type: WalletActionTypes.FETCH_STRIPE_CONNECT_STATUS_START,
  payload: { token },
});

export const fetchStripeConnectStatusSuccess = (data) => ({
  type: WalletActionTypes.FETCH_STRIPE_CONNECT_STATUS_SUCCESS,
  payload: data,
});

export const fetchStripeConnectStatusFailure = (error) => ({
  type: WalletActionTypes.FETCH_STRIPE_CONNECT_STATUS_FAILURE,
  payload: error,
});
